export const DOC_LINKS = {
    MEMBER_IMPORT: 'https://sysem.atlassian.net/wiki/x/DAAJCQ',
    MERCER_KEY_IMPORT: 'https://sysem.atlassian.net/wiki/x/CQANCQ',
}